import { render, staticRenderFns } from "./ftc-modal-button-header.vue?vue&type=template&id=194c821f"
import script from "./ftc-modal-button-header.vue?vue&type=script&lang=js"
export * from "./ftc-modal-button-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports